<template>
<div class="content">
    <div class="countryList">
      <div class="country">
        <span>时间选择：</span>
      </div>
      <div class="country">
        <span @click="checkone()" :class="{ countryon: onehour }">1小时</span>
      </div>
      <div class="country">
        <span @click="checkthree()" :class="{ countryon: threehour }">3小时</span>
      </div>
    </div>
    <div class="iframeDiv flexC" v-if="three">
      <!-- <iframe :src="src[0]" width="100%" height="100%" frameborder="0" scrolling="auto"></iframe> -->
      <img :src="`${src[0]}?t=${Math.random()}`">
    </div>
    <div class="iframeDiv flexC" v-else>
      <img :src="`${src[1]}?t=${Math.random()}`">
    </div>
  </div>
</template>
<script>
export default {
  name: 'Satellite',
  data () {
    return {
      onehour: true,
      threehour: false,
      height: '10px',
      three: false,
      src: []
    }
  },
  methods: {
    checkone () {
      this.three = false
      this.onehour = true
      this.threehour = false
    },
    checkthree () {
      this.three = true
      this.onehour = false
      this.threehour = true
    }
  },
  mounted () {
    let src = this.Global.getIframeUrl(this)
    this.src = src.split(';')
    this.$nextTick(() => {
      // let contentDiv = document.getElementsByClassName('content')
      // let countryListDiv = document.getElementsByClassName('countryList')
      // this.height = (contentDiv[0].offsetHeight - countryListDiv[0].offsetHeight - 45) + 'px'
    })
  }
}
</script>
<style scoped>
.content{
  height: 100%;
  width: 100%;
  /* margin-top:-80px; */
  overflow: hidden;
}
.countryList{
  /* width: 100%; */
  height: 62px;
  background-color: #ffffff;
  border-radius: 5px;
  color: #444444;
  font-size: 15px;
  margin-top: 15px;
  margin-bottom:15px;
}
.country{
  float: left;
  font-family: Microsoft YaHei UI;
  font-size: 15px;
  text-align: center;
  margin-top: 20px;
  margin-left: 0.5%;
  cursor: pointer;
}
.countryon{
  border-radius: 15px;
  background-color: #fda72c;
  color: #ffffff
}
.country span{
  padding: 4px 15px;
}
.iframeDiv{
  width: 100%;
  height: calc(100% - 80px);
  background: #fff;
}
.iframeDiv img{
  height: 100%;
}
.flexC {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
